import { gql } from "graphql-tag";

/**
 * Retrieves the translations of products, categories and prices
 *
 * Here is a variable example
 * {"pscCond": "(id,in,39701)", "pspCond": "(id,in,5910,5967)", "pCond": "(id,in,36896)"}
 */
export const GET_PCsTimeslots = gql`
  query GetPCsTimeslots(
    $categories: String!
    $condition: ConditionTimeSlot
    $skip: Int
    $limit: Int
  ) {
    timeslots: TimeSlotList(
      where: $categories
      condition: $condition
      offset: $skip
      limit: $limit
    ) {
      id: Id
      categoryId: CategoryId
      startDateTime: StartDateTime
      startDateTimeTz: StartDateTimeTz
      endDateTime: EndDateTime
      endDateTimeTz: EndDateTimeTz
      availability: Availability
      availabilityUpdated: AvailabilityUpdated
      booked: Booked
      bookable: Bookable
      estimatedTotalCapacity: EstimatedTotalCapacity
      timeZone: TimeZone
      computedPrices: ComputedPriceList {
        strategyPrice: StrategyPriceRead {
          priceId: ProductSlotPriceId
        }
        TimeSlotId
        startValidity: StartValidity
        endValidity: EndValidity
        priceValue: PriceValue
        isDisplayed: IsDisplayed
        isAvailable: IsAvailable
      }
      psc: ProductSlotCategoryRead {
        ticketGroups: TicketGroupTicketList {
          ticketGroupId: TicketGroupId
        }
      }
      eventKey: EventKey
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;

/**
 *
 * Counts timeslots from backend based on conditions
 */
export const COUNT_PCsTimeslots = gql`
  query CountPCsTimeslots($categories: String!, $condition: ConditionTimeSlot) {
    timeslots: TimeSlotCount(where: $categories, condition: $condition)
  }
`;

/**
 * Fetches timeslots using CategoryId and AvailabilityUpdated
 *
 * variable example
 * { "ids": "(category_id,in,48,49)" }
 */
export const GET_Timeslots = gql`
  query GetTimeslots($categories: String!, $condition: ConditionTimeSlot) {
    # timeslots: TimeSlotList(where: $ids + "~and" + $date) {
    timeslots: TimeSlotList(where: $categories, condition: $condition) {
      id: Id
      categoryId: CategoryId
      availability: Availability
      booked: Booked
      bookable: Bookable
      estimatedTotalCapacity: EstimatedTotalCapacity
      availabilityUpdated: AvailabilityUpdated
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;
